<template>
  <div class="wj_wrap">
      <div class="wj_container">
        <div class="search">
            <span class="lbl_title">合箱编码：</span>
            <el-input id="inputBox" v-model="boxNumber" autofocus ref="inputExpress"
                style="width: 500px;"
                placeholder="请使用扫描枪或手动输入合箱编号，回车确认" 
                :disabled="disable"
                clearable  @clear="inputC()" 
                ></el-input>
            <el-button style="margin-left: 20px;width:120px;padding:20px;border-radio:10px;" 
            @click="confirm()" type="primary" :loading="disable">{{disable?"确认中":"确认"}}</el-button>        
        </div>
      </div>
         <!-- //表格 -->
      <div class="table_container">
        <div class="title">最近签收订单：</div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        stripe
        tooltip-effect="dark"
        ref="table"
      >
        <el-table-column label="名称" min-width="200px" align="center">
          <template slot-scope="scope">
            {{ scope.row.detailList[0].productName }}
          </template>
        </el-table-column>
        <el-table-column
          label="货物类型"
          prop="goodName"
          width="150px"
          align="left"
        >
          <template slot-scope="scope">
            <span>
              <span class="tag" v-if="scope.row.goodType == 1">
                海运
              </span>
              <span class="tag tag3" v-if="scope.row.goodType == 2">
                海运大件
              </span>
              <span class="tag tag1" v-if="scope.row.goodType == 3">
                空运
              </span>
              {{ scope.row.goodName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="派送点"
          prop="deliveryTitle"
          width="120px"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.deliveryTitle }}
          </template>
        </el-table-column>
        <el-table-column
          label="客户"
          prop="userName"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.userName }}
          </template>
        </el-table-column>
        <el-table-column
          label="vip号"
          min-width="80px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.vipCode }}
          </template>
        </el-table-column>
        <el-table-column
          label="物流公司"
          prop="expressCompany"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="运单号"
          prop="expressNo"
          min-width="125px"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.expressNo }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90px" align="center">
            <div style="color: #f59a23">
              已入库
            </div>
        </el-table-column>
        <el-table-column
          label="入库时间"
          width="100px"
          align="center"
        >
        <template slot-scope="scope">
        {{scope.row.storeTime?toDate(scope.row.storeTime,"yyyy-MM-dd hh:mm"):'时间未知'}}
        </template>
        </el-table-column>
        <el-table-column
          label="箱编号"
          min-width="90px"
          align="center"
          prop="boxNumber"
        >
        </el-table-column>
        <el-table-column
          label="货柜号"
          min-width="90px"
          align="center"
          prop="containerName"
        >
        </el-table-column>
      </el-table>
      
      </div>
        <el-dialog
        :visible.sync="dialog.show"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        width="0px"
        height="0px"
        :modal="falseMark"
        :show-close="false"
        @opened="openPass"
        center @close="cancel()"
        >
        <div class="search_result" style="display:none">
           <div class="title">快递签收
             </div>
           <div class="main">
               <div class="tip_msg" v-if="msg">
                    <el-alert :title="msg" type="error" :closable="false"></el-alert>
               </div>
               <el-form ref="form" size="mini">
                 <div v-if="orderInfo" style="padding:0 30px;">
                <el-form-item label="合箱编码：">
                    {{orderInfo.boxNumber}}
                </el-form-item>
                <el-form-item label="用户：">
                    {{orderInfo.vipCodes}}
                </el-form-item>
                <el-form-item label="订单数量：">
                    {{orderInfo && orderInfo.orderCount}}
                </el-form-item>
                <el-form-item label="货物类型：">
                    <span class="tag" v-if="orderInfo.goodType==1">
                      海运
                    </span>
                    <span class="tag tag1" v-else-if="orderInfo.goodType==2">
                      海运大件
                    </span>
                    <span class="tag tag3" v-else-if="orderInfo.goodType==3">
                      空运
                    </span>
                </el-form-item>
                <el-form-item label="派送点：">
                    {{orderInfo && orderInfo.deliveryTitle}}
                </el-form-item>
                <el-form-item label="状态：">
                    <span  class="tag tag4">
                      未入库
                    </span>
                </el-form-item>
                <el-form-item label="时间：">
                   <span v-if="orderInfo && orderInfo.createTime">{{toDate(orderInfo && orderInfo.createTime,"yyyy-MM-dd hh:mm")}} 
                     <span class="tag tag2">
                       合箱
                     </span>
                   </span>
                </el-form-item>
                <el-form-item label="预估费用：">
                   {{total?total:'未知'}}
                </el-form-item>
                <el-form-item label="货柜号：" size="medium">
            <div class="l_item" >
                <el-input style="width: 300px" placeholder="输入货柜号" v-model="viewDialog.boxContainerNumber"></el-input>
                <span class="l_tip">（中转站签收可不填）</span>
            </div>
                </el-form-item>
                <el-form-item label="">
                  <div class="order_detail">
           <div style="text-align:center">
             <span style="font-weight: bolder;font-size: 16px;">订单清单</span>
           </div>
           <div class="product_list">
            <el-table :data="datalist"  border style="width: 100%" stripe>
              <el-table-column
              type="index"
              align="center"
              label="#">
              </el-table-column>
              <el-table-column label="名称" min-width="200px" align="left"
              header-align="center"
              >
                <template slot-scope="scope">
                    {{scope.row.productName }}
                </template>
                </el-table-column>
                <el-table-column
                    label="客户"
                    prop="realName"
                    min-width="70px"
                    align="center"
                >
                    <template slot-scope="scope">
                    {{ scope.row.realName }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="vip号"
                    prop="vipCode"
                    min-width="60px"
                    align="center"
                >
                    <template slot-scope="scope">
                    {{ scope.row.vipCode }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="物流公司"
                    prop="expressCompany"
                    min-width="80px"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="运单号"
                    prop="expressNo"
                    min-width="125px"
                    align="left"
                >
                </el-table-column>
            </el-table>    
           </div>
         </div>
                </el-form-item>
                <el-form-item label="">
                <el-alert title="按回车键签收入库，按ESC取消" type="info" :closable="false"></el-alert>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="confirm()">签收入库</el-button>
                    <el-button type="info" size="medium" @click="cancel()">取消</el-button>
                </el-form-item>
                </div>
                </el-form>
           </div>
        </div>
        </el-dialog>
        <el-dialog
      title="合箱签收"
      :visible.sync="isExistMark"
      width="30%"
      :modal="falseMark"
      :modal-append-to-body="false"
      align="left"
      :destroy-on-close="trueMark"
      @opened="openFail"
      @closed="closed"
    >
      <h1 style="color: #a30014; font-size: 24px; text-align: center">
        签收出错，系统无匹配运单。
      </h1>
      <div class="audioPar"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isExistMark = false">取 消</el-button>
        <el-button type="primary" @click="isExistMark = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isRepeatMark"
      width="30%"
      :modal="falseMark"
      :modal-append-to-body="false"
      align="center"
      :destroy-on-close="trueMark"
      @opened="openRepeat"
    >
      <h1 style="color: #a30014; font-size: 24px">
        合箱签收 &nbsp;({{ orderNum }})
      </h1>
      <br /><br /><br />
      <h1 style="color: #a30014; font-size: 24px">签收出错，本箱已被签收</h1>
      <div class="repeAudioPar"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isRepeatMark = false">取 消</el-button>
        <el-button type="primary" @click="isRepeatMark = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isPassMark"
      width="0px"
      height="0px"
      :modal="falseMark"
      :modal-append-to-body="false"
      align="center"
      :destroy-on-close="trueMark"
      @opened="openPass"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display:none">
        <div class="passAudioPar"></div>
        <audio src="../../../static/audio/rukuSuccess.mp3" autoplay></audio>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isPassMark = false">取 消</el-button>
          <el-button type="primary" @click="isPassMark = false">确 定</el-button>
        </span>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import * as date from "utils/date";
import * as boxApi from "@/api/box";
import * as order from "@/api/order";
import * as deApi from '../../api/debounce'
import * as mUtils from '../../utils/mUtils'
import * as book from '../../api/book'

export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (!value) {
        let text;
        if (rule.field == "vipCode") text = "请输入VIP号";
        else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      total: null,
      orderInfo: [],
      disable: false,
      isSearch: false,
      boxNumber:'',
      datalist:[],
      deliveryTitle:'',
      viewDialog:{
        boxContainerNumber:''
      },
      realName:'',
      msg: "",
      dialog: {
        show: false,
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: "",
        },
        form_rules: {
          vipCode: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          expressCompany: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
        },
      },

      tobeIntoList: [],
      hasIntoList: [],
      isExistMark: false,
      isRepeatMark: false,
      isPassMark: false,
      orderNum: "",
      falseMark:false,
      trueMark:true
    };
  },
  created() {
    this.getAdressId();
    this.getTobeIntoStorList();
    this.getHasIntoStorList();
  },
  watch:{
    boxNumber(){
      if(this.boxNumber.length == 16){
        this.confirm();
      }
      if(this.boxNumber.length > 16){
        this.boxNumber.slice(0,16);
      }
    }
    
  },
  methods: {
    init() {
      this.isSearch = false;
      this.dialog.show = false;
      this.viewDialog=''
      this.orderInfo = [];
      this.msg = "";
      // this.getOrderList();
    },
    inputC(){
      // this.boxNumber = "";
    },
    async confirm() {
      //  if (this.isSearch) return;
      //  this.isSearch = true;
      if(this.boxNumber=='')
      return
      if(this.dialog.show==false){
       this.msg = "";
       let that = this;
       let param ={};
       param.pageIndex= 1;
       param.pageSize = 20;
       param.status = 8;
       param.goodType = null;
       param.boxNumber = that.boxNumber.replace(/\s/g,"");
       param.vipCode = '';
       param.deliveryTitle = '';
       if(that.boxNumber!==''){
        await boxApi.boxList(param).then(res=>{
           if (res.status!==200){
             return  that.$message.error('获取订单异常：'+res.msg) 
           }
           if (res.data.code !=0){
               return that.$message.error(res.data.msg || "获取合箱列表异常")
           }
          if(res.data.data.pageCount!==0)
          that.orderInfo = res.data.data.list[0] || [];
        })
        if(that.orderInfo!==[]&&that.orderInfo.boxNumber==that.boxNumber.replace(/\s/g,"")){
         this.getBoxInfo();
          that.$message({
            message: "入库成功!",
            type: "success",
          });

          that.isPassMark = true;
          clearTimeout(timers);
          let timers = setTimeout(() => {
            that.isPassMark = false;
          }, 0);

        }else{
        //  return  that.$message.error('无法获取该订单：已经入库或不存在') 
          let orderNum = this.boxNumber.trim();

          this.getTobeIntoStorList();
          this.getHasIntoStorList();
          that.orderNum = orderNum;

            const ruleOne = (json) => json.boxNumber == orderNum;
            let resultOne = that.tobeIntoList.some(ruleOne);

            const ruleTwo = (json) => json.boxNumber == orderNum;
            let resultTwo = that.hasIntoList.some(ruleTwo);

            // 订单不存在
            if (!resultOne && !resultTwo) {
              that.isExistMark = true;
              that.boxNumber = "";
            }

            // 订单已入库
            if (!resultOne && resultTwo) {
              that.isRepeatMark = true;
              clearTimeout(timer);
              let timer = setTimeout(() => {
                that.isRepeatMark = false;
              }, 1200);
              that.boxNumber = "";
            }

          
            return;
       }

        }
      }else{
        this.submit();
        // alert(666);
        // this.dialog.show = false; // 我加的 测试 需要的
      }
      this.dialog.show=true
    },

    closed(){
      let inputDom = document.getElementById('inputBox');
      inputDom.focus();
    },
    // 获取派送 待入库数据
    getTobeIntoStorList(){
      let that = this;
      let param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "8";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          return;
        }
        that.tobeIntoList = res.data.data.list || [];
      });
    },

    // 获取派送 已入库数据
    getHasIntoStorList() {
      let that = this;
      let param = {};
      param.pageIndex = "1";
      param.pageSize = "20";
      param.status = "9";
      param.goodType = null;
      param.orderNo = null;
      param.userName = null;
      order.getOrderList(param).then((res) => {
        if (res.data.code != 0)return;
        that.hasIntoList = res.data.data.list || [];
      });
    },

    cancel() {
      this.init();
    },
    openFail(){
      let audioPar = document.getElementsByClassName("audioPar")[0];
      let audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/rukuFail.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openRepeat(){
      let audioPar = document.getElementsByClassName("repeAudioPar")[0];
      let audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/repeatRuku.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openPass(){
      this.confirm();
      // this.dialog.show = false;

      let audioPar = document.getElementsByClassName("passAudioPar")[0];
      let audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/rukuSuccess.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
      this.dialog.show = false;
    },
    submit(){
      //分拨入库提交
      let that = this;
      let param ={};
      param.boxId = this.orderInfo.boxId;
      param.status = 9;
      param.type = 2;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
       });
      boxApi.allocationCentrePut(param).then(res=>{
           loading.close();
           if (res.data.code !=0){
               return that.$message.error(res.data.msg || "操作异常")
           }
          // that.$message({
          //   message: "入库成功!",
          //   type: "success",
          // });
          
          that.boxNumber=''
          that.cancel();
          that.dialog.show=false;
          this.getTobeIntoStorList();
          this.getHasIntoStorList();

      });
    },
    getBoxInfo(){
       let that = this;
       let param ={};
       param.boxId = that.orderInfo.boxId;
       boxApi.allocationCentreInformation(param).then(res=>{
           if (res.data.code !=0){
               that.datalist=[]
               return that.$message.error(res.data.msg || "获取合箱列表异常")
           }
           that.total=res.data.data.totalFreight
           that.datalist = res.data.data.orderPojoList
       })  
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    getOrderList() {
      let that = this;
      let data = {
        pageIndex: 1,
        pageSize: 10,
        status: 9,
        orderNo: '',
        userName: '',
        goodType: null,
        deliveryTitle:this.deliveryTitle
      };
      order.getOrderList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        else if (res.data.code == 0) {
          
            that.tableData = res.data.data.list;
        }else {
            that.$message.error("获取订单列表失败");
        }
      });
    },
    getAdressId(){
          let uselist=mUtils.getStore('userinfo')
          this.realName=uselist.realName
          book.deliveryList({type:2}).then(res=>{
            if(res.status!==200){
              return this.$message.error("获取用户失败："+res.msg)
            }
            if(res.data.code!==0){
              return this.$message.error("获取错误："+res.data.msg)
            }
            if(res.data.data.list!=={}){
              let data=res.data.data.list
              this.addressList=data
              for(let i=0;i<data.length;i++){
                if(data[i].contact==this.realName)
                {
                  this.deliveryTitle=data[i].deliveryTitle
                  this.getOrderList()
                  return
                  }
              }
            }
            this.getOrderList()
          })
        },
  },
  mounted() {
    // 添加键盘Esc事件
    // this.$nextTick(() => {
      document.getElementById('inputBox').addEventListener("keydown", deApi.debounce((e) => {
        if (e.keyCode == 27) {
          this.cancel();
          //this.messageAlert("esc");
        } else if (e.keyCode == 13) {
          // if (!this.orderInfo && this.msg) {
          //   this.cancel();
          // } else {
            this.confirm();
          // }
        }
      },300,true));
    // });
  },
};
</script>
<style  lang="less" scoped>
.wj_wrap {
  padding-bottom: 50px;
  .wj_container {
    width: 800px;
    margin: 50px auto;
    .search {
      .lbl_title {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }

  .tip_msg {
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .no_data {
    margin-top: 30px;
  }
  .search_result {
    min-height: 300px;
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-left: 20px;
    }
    .main {
      margin-top: 20px;
    }
  }
.tag{
  display:inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #e8e8fa;
    border-color: #e9e9eb;
    color: #909399;
  &.tag1{
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2{
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3{
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }&.tag4{
    background-color: #fdf6ec;
    border-color: #fadfd8;
    color: #e6423c;
  }
}
  .table_container {
    width: 85%;
    margin: 0 auto;
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .sign {
      font-size: 12px;
      color: #e6a23c;
    }
  }
}
</style>
<style lang="less">
.wj_container {
  .search {
    .el-input__inner {
      height: 60px;
      line-height: 60px;
      border-radius: 10px;
    }
  }
}
.search_result {
  .el-alert__title {
    font-size: 18px;
  }
  .el-button--medium {
    padding: 10px 40px;
  }
  .el-form-item__label {
    font-size: 18px;
    font-weight: bold;
  }
  .el-form-item__content {
    font-size: 18px;
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin: 15px 0;
  }
}
</style>


// WEBPACK FOOTER //
// fastIn.vue?0657aade